import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import './CursosEducativos.scss';

class CursosEducativos extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();
	}

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Cursos educativos - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home cursos-educativos-home page-gradient page-gradient--yellow bg-gray" ref="cursos-educativos-home">

          <section className="iniciativas-area cursos-educativos-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink to="/estrategias/para-o-mercado" className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">Cursos educativos</h1>
                        </div>
                        <div className="card__content__body">
                          <p>Oferecemos conteúdo para os profissionais aprenderem sobre o mercado ou atualizarem seus conhecimentos. Foram 6.115 alunos nos cursos online, 5.818 nos cursos de atualização das certificações e 751 naqueles oferecidos presencialmente.</p>
													<p>Foram criados seis cursos online em 2019:</p>

													<ul className="bullets bullets--yellow">
														<li>Gestão de risco de mercado;<br /><br /></li>
														<li>Valuation;<br /><br /></li>
														<li>Mercado de renda fixa;<br /><br /></li>
														<li>ETFs (Exchange Traded Funds) no mercado brasileiro;<br /><br /></li>
														<li>Fundos de investimento no exterior;<br /><br /></li>
														<li>Por dentro dos índices de renda fixa.</li>
													</ul>

													<p>
														Também apoiamos o curso de capacitação no mercado financeiro para jovens negros oferecido pelo Infi (Instituto Febraban de Educação), em parceria com a Faculdade Zumbi dos Palmares. Os melhores alunos ganharam a inscrição <span className="gri_text gri_text--fixed">para prestar a CPA-10. <span className="gri_label light-gray">GRI <b>102-12</b></span></span>
													</p>
                          
                        </div>
                      </div>
                      {/* <div className="card__image">
                        <img src={images.iniciativas.raio_x.capa} />
                      </div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="cursos-educativos-body">

            <div className="container container--large">
              <div className="row">
								
                <div className="col-6">
                  <Fade bottom>
                    <div className="card card--no-border card--autorregulacao">
                      <div className="card__content card__content--full">

                        <div className="card__content__body">
													
													<h3 className="title title--small yellow">Cursos de autorregulação</h3>
													<p>Seis novos vídeos foram incluídos no MAP (Módulo de Aprendizagem e Publicações), nossa área educativa voltada aos profissionais das instituições que seguem as normas da autorregulação. Saiba mais:</p>

													<ul className="bullets bullets--yellow">
														<li><strong>Política de certificação:</strong> no vídeo, são explicadas as regras sobre como a empresa deve comunicar a admissão ou o desligamento de profissionais certificados, a necessidade de atualização das certificações e o afastamento de quem não está com a validade do título em dia;<br /><br /></li>
														<li><strong>Certificações:</strong> em dois vídeos, tratamos das qualificações exigidas para os profissionais que distribuem produtos de investimento e fazem gestão de recursos de terceiros;<br /><br /></li>
														<li><strong>Dispensa da prova da CGA (Certificação de Gestores ANBIMA):</strong> explicamos os critérios necessários e como é possível solicitar a dispensa de realização do exame;<br /><br /></li>
														<li><strong>Envio de informações:</strong> o cadastro de novos fundos na base de dados e o preenchimento do laudo de suitability (análise de perfil de investidor) foram temas de outros dois vídeos. Eles trazem orientações gerais para encaminhar os dados e dicas para evitar os erros mais comuns nesses processos.</li>
													</ul>

                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
								
                <div className="col-6">
                  <Fade bottom>
                    <div className="card card--no-border card--autorregulacao">
                      <div className="card__content card__content--full">

                        <div className="card__content__body">
													
													<h3 className="title title--small yellow">Educação de investidores</h3>
													
													<p>Batemos a marca de 35 mil alunos formados no curso Como Investir em Você – Planeje sua Liberdade, lançado em 2014. Oferecidas exclusivamente em 13 universidades parceiras, as aulas ajudam a dar os primeiros passos no mundo da educação financeira e trazem noções de finanças pessoas e planejamento.</p>
													
													<p className="gri_text">
													Em maio, lançamos a segunda edição do curso. Chamada Seja um Investidor, ela traz um simulador de investimentos que ajuda os alunos a entenderem como alcançar seus objetivos financeiros levando em conta as situações e os imprevistos do dia a dia. <span className="gri_label light-gray">GRI <b>203-2</b></span>
													</p>


													<img src={images.iniciativas.cursos_educativos.pessoa} className="pessoa" />

                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

              </div>
            </div>

          </section>

        </div>
      </div>
    );
  }
}

export { CursosEducativos };
